import { ChannelTypeEnum, ReceiveLoginQRCodeData } from "../../types";
import EventBus from "../event-bus";
const receiveLoginQRCodeHook = new EventBus<{
  channelType: ChannelTypeEnum;
  data: ReceiveLoginQRCodeData;
}>("receiveLoginQRCodeHook");

export default receiveLoginQRCodeHook;
